export default __webpack_public_path__ + "src/assets/price-list-template.csv";